import api from "../../api/api";

const API_URL = "/SubCategories"; // change your API

export const getSubCategories = () => api.get(API_URL);

export const getCategoriesDropdown = () =>
  api.get("/Categories");

export const createSubCategory = (data) =>
  api.post(API_URL, data);

export const updateSubCategory = (id, data) =>
  api.put(`${API_URL}/${id}`, data);

export const deleteSubCategory = (id) =>
  api.delete(`${API_URL}/${id}`);